var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortalDashboardmock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Indore Shiksha Sarathi portal UI illustration, based on existing navigation and dashboard sections. Not a screenshot or live data.") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    fill: "#edf4fa"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial,sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 85,
    width: 1130,
    height: 715,
    rx: 22,
    fill: "#fff",
    stroke: "#d4dfe9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 85h1086q22 0 22 22v35H35v-35q0-22 22-22z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 115,
    r: 7,
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 115,
    r: 7,
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 115,
    r: 7,
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 142,
    width: 215,
    height: 636,
    fill: "#123047"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 190,
    fill: "#fff",
    fontSize: 21,
    fontWeight: 700
  }, "Indore Shiksha"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 220,
    fill: "#fff",
    fontSize: 21,
    fontWeight: 700
  }, "Sarathi"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 253,
    width: 188,
    height: 44,
    rx: 8,
    fill: "#2563eb"
  }), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 282,
    fontSize: 17,
    fill: "#fff"
  }, "Dashboard"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 347,
    fontSize: 17,
    fill: "#cedeea"
  }, "Bus Management"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 412,
    fontSize: 17,
    fill: "#cedeea"
  }, "Driver / Conductor"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 477,
    fontSize: 17,
    fill: "#cedeea"
  }, "Schools"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 542,
    fontSize: 17,
    fill: "#cedeea"
  }, "MIS Report"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 607,
    fontSize: 17,
    fill: "#cedeea"
  }, "User Management"), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 142,
    width: 915,
    height: 636,
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 190,
    fill: "#123047",
    fontSize: 28,
    fontWeight: 700
  }, "Dashboard overview"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 235)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 130,
    rx: 12,
    fill: "#fff",
    stroke: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 34,
    height: 34,
    rx: 9,
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 37h14m-7-7v14",
    stroke: "#2563eb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 42,
    fill: "#123047",
    fontSize: 19,
    fontWeight: 700
  }, "Schools"), /*#__PURE__*/React.createElement("path", {
    d: "M22 80h72",
    stroke: "#cbd5e1",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 108h155",
    stroke: "#e2e8f0",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505 235)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 130,
    rx: 12,
    fill: "#fff",
    stroke: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 34,
    height: 34,
    rx: 9,
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 37h14m-7-7v14",
    stroke: "#2563eb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 42,
    fill: "#123047",
    fontSize: 19,
    fontWeight: 700
  }, "Drivers"), /*#__PURE__*/React.createElement("path", {
    d: "M22 80h72",
    stroke: "#cbd5e1",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 108h155",
    stroke: "#e2e8f0",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(730 235)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 130,
    rx: 12,
    fill: "#fff",
    stroke: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 34,
    height: 34,
    rx: 9,
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 37h14m-7-7v14",
    stroke: "#2563eb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 42,
    fill: "#123047",
    fontSize: 19,
    fontWeight: 700
  }, "Conductors"), /*#__PURE__*/React.createElement("path", {
    d: "M22 80h72",
    stroke: "#cbd5e1",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 108h155",
    stroke: "#e2e8f0",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 395,
    width: 540,
    height: 320,
    rx: 12,
    fill: "#fff",
    stroke: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("text", {
    x: 305,
    y: 432,
    fill: "#123047",
    fontSize: 23,
    fontWeight: 700
  }, "Verification overview"), /*#__PURE__*/React.createElement("text", {
    x: 305,
    y: 478,
    fill: "#123047",
    fontSize: 18
  }, "Schools"), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 493,
    width: 480,
    height: 11,
    rx: 5,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 493,
    width: 230,
    height: 11,
    rx: 5,
    fill: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 305,
    y: 554,
    fill: "#123047",
    fontSize: 18
  }, "Drivers"), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 569,
    width: 480,
    height: 11,
    rx: 5,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 569,
    width: 205,
    height: 11,
    rx: 5,
    fill: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 305,
    y: 630,
    fill: "#123047",
    fontSize: 18
  }, "Conductors"), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 645,
    width: 480,
    height: 11,
    rx: 5,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 645,
    width: 180,
    height: 11,
    rx: 5,
    fill: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 395,
    width: 280,
    height: 320,
    rx: 12,
    fill: "#fff",
    stroke: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 432,
    fill: "#123047",
    fontSize: 23,
    fontWeight: 700
  }, "Quick links"), /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 486,
    fill: "#2563eb",
    fontSize: 17
  }, "Bus Management"), /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 544,
    fill: "#2563eb",
    fontSize: 17
  }, "Driver/Conductor List"), /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 602,
    fill: "#2563eb",
    fontSize: 17
  }, "Schools"), /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 660,
    fill: "#2563eb",
    fontSize: 17
  }, "MIS Report"), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 845,
    fill: "#64748b",
    fontSize: 20,
    textAnchor: "middle"
  }, "PORTAL UI ILLUSTRATION - NO LIVE RECORDS OR COUNTS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalDashboardmock);
export default __webpack_public_path__ + "static/media/portal-dashboard.mock.72b082ad549055111a0fa188be42f7ce.svg";
export { ForwardRef as ReactComponent };